import router from '../router'
import b2cAuthService from '@/auth/b2cAuthService'
import axios from 'axios'

export default {
    namespaced: true,

    state: {
        username: null,
        user: {},
        token: null,
        isLoggedIn: false,
        b2cAccount: null,
        overrideEndpointsUsers: [
            'appcentricltd.com',
            'appcentric.co.uk',
            'jmo.dcl2@gmail.com',
            'medicines.org.uk',
            'datapharm.com'
        ],
        handshakeData: {}
    },

    getters: {
        getUserToken(state) {
            return state.token
        },
        getUser(state) {
            return state.user
        },
        getUsername(state) {
            return state.username
        },
        getIsUserLoggedIn(state) {
            return state.username != null && state.isLoggedIn
        },
        getOverrideEndpointsUsers(state) {
            return state.overrideEndpointsUsers
        },
        getB2CAccount(state) {
            return state.b2cAccount
        },
        getHandshakeData(state) {
            return state.handshakeData
        },
        getProfileUrl(state) {
            return state.handshakeData.profileUrl
        }
    },

    mutations: {
        SET_B2C_AUTH_DATA(state, data) {
            state.username = data.username
            state.token = data.accessToken
            state.user = data.userInfo
            state.b2cAccount = data.account
            state.isLoggedIn = true
        },
        REMOVE_AUTH_DATA(state) {
            state.user = {}
            state.token = null
            state.isLoggedIn = false
            state.b2cAccount = null
            state.handshakeDat = {}
        },
        SET_HANDSHAKE_DATA(state, data) {
            state.handshakeData = data
        }
    },

    actions: {
        async getToken({commit}) {
            try {
                const account = b2cAuthService.getAccount()
                if (account) {
                    const accessToken = await b2cAuthService.acquireTokenSilent()
                    const userInfo = b2cAuthService.getUserInfo()

                    commit('SET_B2C_AUTH_DATA', {
                        username: userInfo.username,
                        accessToken: accessToken,
                        userInfo: userInfo,
                        account: account
                    })

                    return router.replace({name: 'Portfolio'})
                } else {
                    // No account, B2C redirect will be handled by main.js
                    return
                }
            } catch (error) {
                console.error('B2C token retrieval error:', error)
                // Error will trigger B2C redirect in main.js
            }

            // No auth data - B2C mode will handle redirect in main.js
        },

        async loginB2C() {
            try {
                // Redirect flow - will redirect away and come back
                await b2cAuthService.signInRedirect()
            } catch (error) {
                console.error('B2C login error:', error)
                throw new Error('Error logging in with B2C')
            }
        },

        // Compatibility method
        async login({dispatch}) {
            return dispatch('loginB2C')
        },

        async logout({commit}) {
            try {
                // B2C signOut will redirect to B2C logout page and then back to the app
                // which will trigger a fresh login redirect
                await b2cAuthService.signOut()
            } catch (error) {
                console.error('B2C logout error:', error)
            }

            commit('REMOVE_AUTH_DATA')

            // Page will reload after B2C signOut
            return router.go()
        },

        async refreshB2CToken({commit}) {
            try {
                const accessToken = await b2cAuthService.acquireTokenSilent()
                const userInfo = b2cAuthService.getUserInfo()
                const account = b2cAuthService.getAccount()

                commit('SET_B2C_AUTH_DATA', {
                    username: userInfo.username,
                    accessToken: accessToken,
                    userInfo: userInfo,
                    account: account
                })

                return accessToken
            } catch (error) {
                console.error('Token refresh error:', error)
                throw error
            }
        },

        async handshake({commit}) {
            try {
                const response = await axios.get('/Handshake_Pwa/v2')
                commit('SET_HANDSHAKE_DATA', response.data.results)
            } catch(error) {
                console.error('Handshake error:', error)
            }
        }
    }
}
